import React from 'react';

// Provides context for the Snackbar component.
const SnackbarContext = React.createContext([] as string[]);
export default SnackbarContext;
